export var createPortalColor = {
  text: {
    black: {
      base: function base(_ref) {
        var palette = _ref.palette;
        return palette.neutralsBlack.hex80;
      },
      disable: function disable(_ref2) {
        var palette = _ref2.palette;
        return palette.neutralsBlack.hex50;
      }
    },
    white: {
      base: function base(_ref3) {
        var palette = _ref3.palette;
        return palette.neutralsWhite.hex80;
      },
      disable: function disable(_ref4) {
        var palette = _ref4.palette;
        return palette.neutralsWhite.hex20;
      }
    },
    secondary: {
      base: function base(_ref5) {
        var palette = _ref5.palette;
        return palette.neutralsBlack.hex50;
      },
      disable: function disable(_ref6) {
        var palette = _ref6.palette;
        return palette.neutralsBlack.hex30;
      }
    },
    placeholder: {
      base: function base(_ref7) {
        var palette = _ref7.palette;
        return palette.neutralsBlack.hex30;
      },
      disable: function disable(_ref8) {
        var palette = _ref8.palette;
        return palette.neutralsBlack.hex50;
      }
    },
    link: {
      base: function base(_ref9) {
        var palette = _ref9.palette;
        return palette.newBlue.hex60;
      },
      hover: function hover(_ref10) {
        var palette = _ref10.palette;
        return palette.newOrange.hex50;
      },
      visited: function visited(_ref11) {
        var palette = _ref11.palette;
        return palette.newViolet.hex50;
      }
    }
  },
  fill: {
    page: {
      back: function back(_ref12) {
        var palette = _ref12.palette;
        return palette.neutralsBlack.hex5;
      }
    },
    input: {
      base: function base(_ref13) {
        var palette = _ref13.palette;
        return palette.neutralsBlack.hex5;
      },
      disable: function disable(_ref14) {
        var palette = _ref14.palette;
        return palette.neutralsBlack.hex10;
      }
    },
    item: {
      base: function base(_ref15) {
        var palette = _ref15.palette;
        return palette.neutralsWhite.hex100;
      },
      hover: function hover(_ref16) {
        var palette = _ref16.palette;
        return palette.neutralsBlack.hex5;
      },
      selected: function selected(_ref17) {
        var palette = _ref17.palette;
        return palette.neutralsBlack.hex10;
      }
    },
    icon: {
      base: function base(_ref18) {
        var palette = _ref18.palette;
        return palette.neutralsBlack.hex50;
      },
      hover: function hover(_ref19) {
        var palette = _ref19.palette;
        return palette.neutralsBlack.hex80;
      }
    }
  },
  border: {
    hr: {
      base: function base(_ref20) {
        var palette = _ref20.palette;
        return palette.neutralsBlack.hex8;
      }
    },
    input: {
      base: function base(_ref21) {
        var palette = _ref21.palette;
        return palette.neutralsBlack.hex15;
      },
      hover: function hover(_ref22) {
        var palette = _ref22.palette;
        return palette.neutralsBlack.hex20;
      },
      invalid: {
        base: function base(_ref23) {
          var palette = _ref23.palette;
          return palette.newRed.hex20;
        },
        hover: function hover(_ref24) {
          var palette = _ref24.palette;
          return palette.newRed.hex30;
        }
      }
    },
    focus: {
      base: function base(_ref25) {
        var palette = _ref25.palette;
        return palette.newBlue.hex40;
      },
      hover: function hover(_ref26) {
        var palette = _ref26.palette;
        return palette.newBlue.hex50;
      },
      invalid: {
        base: function base(_ref27) {
          var palette = _ref27.palette;
          return palette.newRed.hex20;
        },
        hover: function hover(_ref28) {
          var palette = _ref28.palette;
          return palette.newRed.hex30;
        }
      }
    }
  },
  importance: {
    primary: {
      base: function base(_ref29) {
        var palette = _ref29.palette;
        return palette.newBlue.hex50;
      },
      hover: function hover(_ref30) {
        var palette = _ref30.palette;
        return palette.newBlue.hex60;
      },
      active: function active(_ref31) {
        var palette = _ref31.palette;
        return palette.newBlue.hex70;
      },
      disable: function disable(_ref32) {
        var palette = _ref32.palette;
        return palette.newBlue.hex10;
      },
      light: function light(_ref33) {
        var palette = _ref33.palette;
        return palette.newBlue.hex5;
      }
    },
    secondary: {
      base: function base(_ref34) {
        var palette = _ref34.palette;
        return palette.neutralsBlack.rgba8;
      },
      hover: function hover(_ref35) {
        var palette = _ref35.palette;
        return palette.neutralsBlack.rgba15;
      },
      active: function active(_ref36) {
        var palette = _ref36.palette;
        return palette.neutralsBlack.rgba20;
      },
      selected: function selected(_ref37) {
        var palette = _ref37.palette;
        return palette.newBlue.hex10;
      },
      disable: function disable(_ref38) {
        var palette = _ref38.palette;
        return palette.neutralsBlack.rgba5;
      },
      light: function light(_ref39) {
        var palette = _ref39.palette;
        return palette.neutralsBlack.rgba5;
      }
    },
    success: {
      base: function base(_ref40) {
        var palette = _ref40.palette;
        return palette.newGreen.hex50;
      },
      hover: function hover(_ref41) {
        var palette = _ref41.palette;
        return palette.newGreen.hex60;
      },
      active: function active(_ref42) {
        var palette = _ref42.palette;
        return palette.newGreen.hex70;
      },
      disable: function disable(_ref43) {
        var palette = _ref43.palette;
        return palette.newGreen.hex20;
      },
      light: function light(_ref44) {
        var palette = _ref44.palette;
        return palette.newGreen.hex5;
      }
    },
    attention: {
      base: function base(_ref45) {
        var palette = _ref45.palette;
        return palette.newOrange.hex50;
      },
      hover: function hover(_ref46) {
        var palette = _ref46.palette;
        return palette.newOrange.hex60;
      },
      active: function active(_ref47) {
        var palette = _ref47.palette;
        return palette.newOrange.hex70;
      },
      disable: function disable(_ref48) {
        var palette = _ref48.palette;
        return palette.newOrange.hex20;
      },
      light: function light(_ref49) {
        var palette = _ref49.palette;
        return palette.newOrange.hex5;
      }
    },
    danger: {
      base: function base(_ref50) {
        var palette = _ref50.palette;
        return palette.newRed.hex50;
      },
      hover: function hover(_ref51) {
        var palette = _ref51.palette;
        return palette.newRed.hex60;
      },
      active: function active(_ref52) {
        var palette = _ref52.palette;
        return palette.newRed.hex70;
      },
      disable: function disable(_ref53) {
        var palette = _ref53.palette;
        return palette.newRed.hex20;
      },
      light: function light(_ref54) {
        var palette = _ref54.palette;
        return palette.newRed.hex5;
      }
    },
    transparency: {
      base: function base(_ref55) {
        var palette = _ref55.palette;
        return palette.transparent;
      },
      hover: function hover(_ref56) {
        var palette = _ref56.palette;
        return palette.transparent;
      },
      active: function active(_ref57) {
        var palette = _ref57.palette;
        return palette.transparent;
      },
      disable: function disable(_ref58) {
        var palette = _ref58.palette;
        return palette.transparent;
      }
    }
  }
};